import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class MaintenanceResponseInterceptor implements HttpInterceptor {

    constructor(private router: Router, private route: ActivatedRoute) { }

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err?.error?.error == 'Site em manutenção') {
            const extra = err?.error?.extra
            localStorage.setItem('maintenance_extra', JSON.stringify(extra));

            this.router.navigate(['/maintenance']);
        } else {
            localStorage.removeItem('maintenance_extra');
        }

        return throwError(err);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let local: string | null = null

        if (localStorage.getItem('maintenance_extra')) {
            local = localStorage.getItem('maintenance_extra')
        }
        
        if (window.location.pathname == "/maintenance" && !local) {
            this.router.navigate(["/"])
        }

         if (window.location.pathname !== "/maintenance" && local) {
            this.router.navigate(["/maintenance"])
        }

        localStorage.removeItem('maintenance_extra');

        return next.handle(request)
            .pipe(catchError(err => this.handleAuthError(err)));
    }
}
